export const emitUnitEvent = (
    unitId: number | string,
    facilityId: number,
    promoId: number | string | undefined = 0,
    eventType: "rental" | "reservation" | "inquiry",
) => {
    const message = {
        type: `seUnitTable:unit${eventType.toUpperCase()}`,
        detail: {
            facilityId,
            unitId,
            promoId,
            timeStamp: new Date(),
            locationId: 0,
        },
    };
    window.postMessage(message, "*");
};
